import { post } from "foundation/js/api"
import { defineStore } from "pinia"

export const useFormsStore = defineStore("forms", {
    state: () => ({
        isSubmitting: false,
        errors: {},
        success: {},
    }),
    getters: {},
    actions: {
        async submitContactForm(payload) {
            this.isSubmitting = true
            const url = `${document.location.origin}/${process.env.POST_FORM_CONTACT.replace('[guid]', payload.guid)}`
            const body = JSON.stringify(payload.body)
            const response = await post(url, body)
            this.updateForm({
                guid: payload.guid,
                errorObject: {
                    error: response.status > 200,
                    title: response?.title ?? '',
                    detail: response?.detail ?? '',
                    type: response?.type ?? '',
                },
                successObject: { 
                    success: response?.text ? true : false, 
                    text: response?.text ?? '' 
                }
            })
        },
        async submitSaleForm(payload) {
            this.isSubmitting = true
            const url = `${document.location.origin}/${process.env.POST_FORM_SALE.replace('[guid]', payload.guid)}`

            const body = JSON.stringify(payload.body)
            const response = await post(url, body)

            this.updateForm({
                guid: payload.guid,
                errorObject: {
                    error: response.status > 200,
                    title: response?.title ?? '',
                    detail: response?.detail ?? '',
                    type: response?.type ?? '',
                },
                successObject: { 
                    success: response?.text ? true : false, 
                    text: response?.text ?? '' 
                }
            })
        },
        updateForm(payload) {
            this.isSubmitting = false
            this.errors[payload.guid] = payload.errorObject,
            this.success[payload.guid] = payload.successObject
        },
    },
})
